'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wrappedUpdateBlockMetadata = require('../richUtils/wrappedUpdateBlockMetadata');

var _wrappedUpdateBlockMetadata2 = _interopRequireDefault(_wrappedUpdateBlockMetadata);

var _returnFocusToEditor = require('../richUtils/returnFocusToEditor');

var _returnFocusToEditor2 = _interopRequireDefault(_returnFocusToEditor);

var _ChecklistEditorBlock = require('./components/ChecklistEditorBlock');

var _ChecklistEditorBlock2 = _interopRequireDefault(_ChecklistEditorBlock);

var _checklistConstants = require('./checklistConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides the component to be rendered by the block type as well as any props that go with it.
 */


// Components
// Utils
exports.default = function (block, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState,
        getProps = _ref.getProps;

    if (block.getType() !== _checklistConstants.CHECKLIST_BLOCK_TYPE) return null;

    var props = getProps();

    return {
        component: _ChecklistEditorBlock2.default,
        props: {
            isEditable: props.isEditable,
            updateMetadataFn: (0, _wrappedUpdateBlockMetadata2.default)(getEditorState, setEditorState),
            returnFocusToEditor: (0, _returnFocusToEditor2.default)(props, { getEditorState: getEditorState, setEditorState: setEditorState }),
            checked: !!block.getData().get('checked')
        }
    };
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/blockRendererFn.js
// module id = 1719
// module chunks = 0